// /c-preview — the branded chat page as the dashboard's live preview shows
// it (frontend-app, Agent → Branded page). The editor puts this page in an
// iframe and posts the unsaved settings into it, so the preview is the real
// page component, not a drawing of it: what the owner sees is what visitors
// get.
//
// Only messages from the dashboard's own origin are accepted, and only from
// the window that embeds us. The page is drawn with `preview` on: no chat,
// nothing stored. Everything shown is rendered as text, as on the live page.
import { useEffect, useState } from 'react';
import { Ready } from './BrandPage';

const MESSAGE = 'jawabai:brand-page-preview';

function allowedOrigins() {
  const list = [];
  try {
    list.push(new URL(import.meta.env.VITE_APP_URL || 'https://app.jawabai.cloud').origin);
  } catch {
    // a malformed VITE_APP_URL accepts nothing rather than everything
  }
  if (import.meta.env.DEV) list.push('http://localhost:5173');
  return list;
}

export default function BrandPagePreview() {
  const [page, setPage] = useState(null);

  useEffect(() => {
    const origins = allowedOrigins();
    const onMessage = (e) => {
      if (e.source !== window.parent || !origins.includes(e.origin)) return;
      const data = e.data;
      if (data?.type !== MESSAGE || typeof data.page?.name !== 'string') return;
      setPage(data.page);
    };
    window.addEventListener('message', onMessage);
    // Tell the editor we are listening; it answers with the current settings.
    // Nothing secret here, so any parent may hear it.
    if (window.parent !== window) window.parent.postMessage({ type: `${MESSAGE}:ready` }, '*');
    return () => window.removeEventListener('message', onMessage);
  }, []);

  if (!page) return <div className="h-dvh bg-bg" />;
  return <Ready page={page} slug="preview" preview />;
}
